import {
    Button,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Stack,
} from '@chakra-ui/react';
import { useActions } from '../../hooks/actions';
import { useAppSelector } from '../../hooks/redux';
import Colors from '../../config/colors';
import About from '../about/About';
import { useTelegram } from '../../hooks/useTelegram';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../../config/locales/locales';

import ReactCountryFlag from 'react-country-flag';
import ProfileLinks from '../profileLinks/ProfileLinks';
import { PROFILE_LINKS } from '../../config/profileLinks';

export default function Profile() {
    const { user, onClose } = useTelegram();
    const isOpen = useAppSelector((state) => state.navigation.isOpen);
    const { t, i18n } = useTranslation();

    const { setOpen } = useActions();

    const closeModal = () => {
        setOpen(false);
    };

    const setOpenHandler = (isOpen: boolean) => {
        setOpen(isOpen);
    };

    const changeLanguage = (language: any) => {
        i18n.changeLanguage(language);
        localStorage.setItem('lng', language);
    };

    return (
        <>
            <Drawer
                isOpen={isOpen}
                placement="right"
                onClose={() => setOpenHandler(false)}
                autoFocus={false}>
                <DrawerOverlay />
                <DrawerContent maxW="200px" background="#171A21" color="#BDBDBD">
                    <DrawerHeader
                        borderBottomWidth="1px"
                        fontSize="14px"
                        fontWeight="500"
                        textAlign="center"
                        borderColor="#000">
                        {t('profile')}
                    </DrawerHeader>
                    <DrawerBody
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between">
                        <Stack>
                            {user && (
                                <About
                                    userId={user?.id}
                                    name={user?.firstName}
                                    login={user?.username}
                                />
                            )}

                            <ProfileLinks profileLinks={PROFILE_LINKS} closeModal={closeModal} />
                        </Stack>
                        <Stack direction="row" spacing="10px" mb="30px">
                            {LOCALES.map(({ shortName }) => (
                                <Button
                                    borderRadius="0"
                                    variant="none"
                                    onClick={() => changeLanguage(shortName)}
                                    width="100%"
                                    borderColor={
                                        i18n.language === shortName ? '#2f3138' : '#2f3138'
                                    }
                                    borderWidth="1px"
                                    color={
                                        i18n.language === shortName ? Colors.lightBlue : '#BDBDBD'
                                    }
                                    fontWeight="300"
                                    display="flex"
                                    gap="6px"
                                    fontSize="14px">
                                    {shortName.toUpperCase()}
                                    <ReactCountryFlag
                                        countryCode={shortName === 'en' ? 'us' : shortName}
                                        svg
                                    />
                                </Button>
                            ))}
                        </Stack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
}
